<template>
  <div class="sv-page">
    <header class="sv-page-header">
      <div>
        <span class="sv-page-header__eyebrow">Acompanhamento ao vivo</span>
        <h1>Realtime</h1>
        <p>Acompanhe a entrada e o processamento das gravações em tempo real.</p>
      </div>
    </header>

    <div class="row">
      <div class="col-xxl-12">
        <RealtimeTable />
      </div>
      <div class="col-xxl-3 custom-realtime-mobile">
        <RealtimeUploadSuccessCard/>
        <RealtimeUploadErrorCard/>
      </div>
      <div class="col-xxl-3 custom-realtime-mobile">
        <RealtimeUploadTotalSize/>
        <RealtimeUploadTotalDuration/>
      </div>
      <div class="col-xxl-6">
        <RealtimeUploadTimers />
      </div>
    </div>
  </div>
</template>

<script>
import Pusher from 'pusher-js';
import { defineComponent } from "vue";
import { mapGetters, mapActions } from 'vuex';

import RealtimeUploadSuccessCard from "../../components/Realtime/RealtimeUploadSuccessCard.vue";
import RealtimeUploadErrorCard from "../../components/Realtime/RealtimeUploadErrorCard.vue";
import RealtimeUploadTotalSize from "../../components/Realtime/RealtimeUploadTotalSize.vue";
import RealtimeUploadTotalDuration from "../../components/Realtime/RealtimeUploadTotalDuration.vue";
import RealtimeUploadTimers from "../../components/Realtime/RealtimeUploadTimers.vue";
import RealtimeTable from "../../components/Realtime/RealtimeTable.vue";

export default defineComponent({
  name: "RealtimePage",
  components: {
    RealtimeUploadErrorCard,
    RealtimeUploadSuccessCard,
    RealtimeUploadTotalSize,
    RealtimeUploadTotalDuration,
    RealtimeUploadTimers,
    RealtimeTable
  },
  data () {
      return {
          pusher: null,
          logs: []
      }
  },
  computed:{
    ...mapGetters([
      'getRealtime',
      'getRealtimeChannel',
      'getConfigurations'
    ])
  },
  methods: {
    ...mapActions([
        "setNewLog",
        "setLastMetricsTimers",
        "setLastMetricsCard",
        "setNewStatusAddSuccess",
        "setNewStatusAddError",
        "setRealtimeChannel",
        "setConfiguration"
    ]),
  },
  mounted() {
    this.setLastMetricsCard();
    this.setLastMetricsTimers();

    this.pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
        cluster: process.env.VUE_APP_PUSHER_CLUSTER
    });

    const pusher = this.pusher
    const setNewLog = this.setNewLog;
    const setNewStatusAddSuccess = this.setNewStatusAddSuccess;
    const setNewStatusAddError = this.setNewStatusAddError;

    this.setConfiguration().then(() => {

      console.log("Opinhaaa: ", this.getConfigurations);
      if(pusher){

        var channel = pusher.subscribe('logRealtime-'+this.getConfigurations.company_id);
        
        channel.bind('uploadFile-'+this.getConfigurations.company_id+localStorage.getItem("selected_operation_id"), function(data) {

            setNewLog(data);
  
            if(data.data && data.statusCode){
              if(data.statusCode == 200){
                setNewStatusAddSuccess(data.data)
              } else {
                setNewStatusAddError(data.data);
              }
            }
        });
      }
    });


  },
  unmounted(){
    if(this.pusher != null){
      this.pusher.unsubscribe('logRealtime-'+this.getConfigurations.company_id);
    }
  }
});
</script>
